var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-widget"},[_c('p',[_vm._v("Error finding and mounting specified widget")])])
}]

export { render, staticRenderFns }